/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge18 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important;
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])
	return <div className={`w-100 flex-centered edge-${id}`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		>  
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M184.6,18.9l0,0.8l0,0.8c0.1,1.5,0.4,2.9,0.7,4.1c0.7,2.8,1.8,5.4,3.3,7.9c0.8,1.3,1.7,2.4,2.5,3.3c1,1.1,2,2.1,3,3.2
				c2.2,2.2,4.6,4.1,6.7,5.8c-0.1,0-0.1,0.1-0.2,0.2c1,0.6,2,1.1,3,1.7c0.3-0.1,0.5-0.3,0.8-0.4c0.5-0.3,1-0.7,1.5-1.1l0.3-0.2
				c0.7-0.5,1.3-1,2-1.5c0.6-0.4,1.1-0.8,1.7-1.2c1.1-0.8,2.1-1.7,3.3-2.6l0.6-0.5c0.6-0.5,1.2-1,1.8-1.5c0.7-0.6,1.4-1.2,2-1.8
				l0.3-0.4l0.6-0.7c0.1-0.2,0.3-0.3,0.4-0.5l0.2-0.2l0.2-0.3c0.5-0.6,0.9-1.2,1.3-1.8c0.4-0.6,0.6-1.1,0.8-1.5
				c0.3-0.6,0.4-1.3,0.5-1.8c0.1-0.5,0.2-0.9,0.2-1.5l0-0.3c0.1-0.6,0.1-1.2,0.1-1.8c0-0.5,0-1,0-1.5c0-0.8,0-1.6-0.1-2.4
				c-0.2-1.9-0.9-4.5-2.8-6.4c-0.9-0.8-1.8-1.4-2.9-1.5c-1.3-0.2-2.5,0.5-3.5,1.1c-1.2,0.7-2.4,1.7-3.7,3c-2,2-3.7,4.5-5,7.3
				c-0.3,0.5-0.5,1.1-0.8,1.6l-0.1,0.2l0-0.1c0-0.3-0.1-0.6-0.2-0.9c-0.5-2.5-1-4.9-1.9-7.2c-0.9-2.4-2-4.4-3.5-5.9
				c-1.8-1.9-4-2.9-6.2-3c-2.5,0-4.7,1.2-5.9,3.1c-0.3,0.5-0.6,1-0.7,1.6c-0.2,0.5-0.3,1.1-0.4,1.6c-0.2,0.9-0.3,1.8-0.3,2.7
				C184.6,18.4,184.6,18.6,184.6,18.9L184.6,18.9L184.6,18.9z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M231.9,18.4c0.4,1.8,1.1,3.5,2,5.1c0.4,0.7,0.7,1.4,1.1,2.1c0.4,0.6,0.7,1.2,1.1,1.8c0.7,1.2,1.4,2.3,2.1,3.4
				c0.8,1.2,1.6,2.4,2.6,3.6c1.2,1.5,2.4,2.9,3.8,4.2c1.3,1.2,2.8,2.3,4.3,3.3c0.8,0.5,1.6,1,2.5,1.5c0.8,0.5,1.7,1,2.5,1.5
				c0.4,0.2,0.7,0.4,1.1,0.3c0.2,0,0.4-0.1,0.6-0.2c0.2,0.1,0.4,0.1,0.6,0c0.4,0,0.8-0.3,1-0.6c1.6-2.7,3-5.5,4.4-8.3
				c1.4-2.8,2.9-5.7,4-8.6c0.8-1.9,1.5-3.8,1.8-5.8c0.3-2.2-0.1-4.5-1.1-6.5c-1-2-3.1-3.9-5.5-3.7c-2.3,0.2-4.2,1.9-5.6,3.5
				c-0.6,0.6-1.2,1.3-1.7,1.9c-0.6,0.7-1.1,1.3-1.6,2c-0.5,0.7-1,1.3-1.5,2c-0.7-1.3-1.3-2.6-2-3.8c-1.3-2.1-2.6-4.3-4.3-6
				c-1.6-1.6-3.8-2.9-6.2-2.7c-0.5,0-1.1,0.1-1.6,0.3c-0.5,0.2-1,0.4-1.4,0.7c-1,0.6-1.7,1.6-2.3,2.6c-0.6,1-0.9,2.1-1,3.2
				c0,0.4-0.1,0.7-0.1,1.1C231.6,16.8,231.7,17.6,231.9,18.4L231.9,18.4L231.9,18.4z M234.7,16c0-0.6,0.1-1.1,0.2-1.7
				c0.2-0.5,0.3-1,0.6-1.5c0.2-0.3,0.4-0.5,0.6-0.8c0.2-0.2,0.5-0.4,0.8-0.6c0.2-0.1,0.4-0.2,0.6-0.3c0.3-0.1,0.6-0.1,0.8-0.1
				c0.3,0,0.7,0.1,1,0.1c0.4,0.1,0.8,0.3,1.2,0.5c0.6,0.4,1.2,0.9,1.7,1.4c1.5,1.6,2.6,3.5,3.8,5.3c0.5,1,1.1,2,1.6,3
				c0.1,0.3,0.3,0.5,0.4,0.8c0.3,0.6,0.6,1.2,1.1,1.6c0.3,0.2,0.7,0.4,1.1,0.4c0.5,0.1,1-0.2,1.5-0.4c0.7-0.4,1.2-1.1,1.7-1.8
				c0.7-0.9,1.4-1.9,2.2-2.9c0.9-1.1,1.8-2.1,2.8-3.1c0.6-0.5,1.1-1,1.8-1.4c0.3-0.1,0.5-0.3,0.8-0.4c0.1,0,0.3,0,0.4-0.1
				c0.1,0,0.3,0,0.4,0.1c0.2,0.1,0.3,0.1,0.5,0.2c0.3,0.2,0.5,0.4,0.8,0.6c0.2,0.3,0.4,0.6,0.6,0.9c0.3,0.6,0.5,1.1,0.7,1.7
				c0.2,0.7,0.3,1.4,0.3,2.1c0,1.2-0.3,2.3-0.6,3.4c-0.5,1.5-1.1,3-1.7,4.4c-0.7,1.5-1.4,3-2.1,4.4c-1.4,2.8-2.7,5.6-4.3,8.4
				c-0.3,0.5-0.5,0.9-0.8,1.4c-0.7-0.4-1.4-0.9-2.1-1.3c-0.9-0.5-1.8-1.1-2.7-1.6c-1.7-1.1-3.2-2.3-4.6-3.7C242.5,32,240,28,237.6,24
				c-0.3-0.6-0.7-1.3-1-1.9c-0.7-1.2-1.2-2.5-1.6-3.9C234.8,17.5,234.7,16.8,234.7,16L234.7,16L234.7,16z M245.5,35.2
				c0.1,0.1,0.2,0.2,0.2,0.2C245.7,35.3,245.6,35.2,245.5,35.2L245.5,35.2L245.5,35.2z M258.1,16.4C258.2,16.4,258.2,16.3,258.1,16.4
				C258.2,16.3,258.2,16.4,258.1,16.4L258.1,16.4L258.1,16.4z M264,23.8c0-0.1,0-0.1,0.1-0.2C264,23.6,264,23.7,264,23.8L264,23.8
				L264,23.8z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M272.6,15.6c0,1.5,0.3,3,0.6,4.4c0.5,2.3,1.4,4.5,2.4,6.6c0.8,1.5,1.7,3,3,4.8c0.3,0.5,0.7,0.9,1,1.3l0.4,0.5
				c0.8,1.1,1.6,2.1,2.5,3.2c1.9,2.4,3.9,4.9,5.9,7.4c0.2,0.2,0.4,0.4,0.6,0.5c0.3,0.8,1.2,1.1,2,0.8c0.5-0.2,0.9-0.6,1.3-1
				c0.3-0.3,0.5-0.6,0.8-0.9c0.5-0.6,0.9-1.1,1.4-1.7c0.9-1.1,1.9-2.3,2.8-3.7c2.1-2.9,3.8-6,5.2-8.7c0.3-0.5,0.6-1.1,0.8-1.6
				l0.3-0.7l0.1-0.3c0.4-0.9,0.7-1.9,0.9-2.8c0.4-1.4,0.5-2.8,0.5-4.1c0-0.7,0-1.3-0.1-2c-0.3-2.1-1.3-3.9-2.7-4.9
				c-1.5-1.1-3.7-1.3-5.6-0.5c-0.9,0.4-1.7,1-2.2,1.4c-0.7,0.6-1.3,1.3-2,2.2c-0.9,1.2-1.7,2.7-2.3,4.4l-0.1,0.4
				c-0.2-0.7-0.5-1.3-0.8-2c-0.3-0.8-0.7-1.6-1.2-2.6c-0.5-1-1.1-2-1.7-3c-0.6-0.9-1.4-1.8-2.4-2.7c-0.8-0.7-1.7-1.3-2.7-1.7
				c-1.2-0.5-2.5-0.7-3.6-0.5c-1.1,0.2-1.9,0.8-2.7,1.7c-0.8,0.8-1.5,1.9-1.8,2.9C272.7,13.8,272.6,14.6,272.6,15.6L272.6,15.6
				L272.6,15.6z"/> 
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M173.5,25.4H89c-2.7,0-2.7,4.2,0,4.2h84.5C176.2,29.6,176.2,25.4,173.5,25.4z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M321.6,25.4h84.5c2.7,0,2.7,4.2,0,4.2h-84.5C318.8,29.6,318.8,25.4,321.6,25.4z"/>
		</svg>
	</div>
}

